export default "__VITE_ASSET__feLOWjhn__"